import React, { ReactElement, useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
    isOkq8,
    isVillaagarna
} from '../../../services/partners/partnersService';
import { withRouter } from 'react-router-dom';

export interface Stepable {
    goToNextStep?: Function;
    goToPrevStep?: Function;
}

const StepManager = ({ children }) => {
    const [step, setStep] = useState(0);
    const history = useHistory();

    const goToNextStep = () => {
        setStep(step + 1);
        if (
            history.location.pathname &&
            history.location.pathname.includes('/home')
        ) {
            if (!(isVillaagarna() || isOkq8())) {
                switch (step + 1) {
                    case 1:
                        history.push('/home/offer');
                        break;
                    case 2:
                        history.push('/home/summary');
                        break;
                    default:
                        history.push('/home/calculation');
                        break;
                }
            }
        }
    };

    const goToPrevStep = doNotReload => {
        if (step - 1 >= 0) {
            if (!doNotReload) {
                if (
                    history.location.pathname &&
                    history.location.pathname.includes('/home') &&
                    !(isVillaagarna() || isOkq8())
                ) {
                    switch (step - 1) {
                        case 0:
                            history.push('/home/calculation');
                            break;
                        case 1:
                            history.push('/home/offer');
                            break;
                        default:
                            history.push('/home/calculation');
                            break;
                    }
                }
                window.location.reload();
            } else {
                setStep(step - 1);
                if (
                    history.location.pathname &&
                    history.location.pathname.includes('/home')
                ) {
                    if (!(isVillaagarna() || isOkq8())) {
                        switch (step - 1) {
                            case 0:
                                history.push('/home/calculation');
                                break;
                            case 1:
                                history.push('/home/offer');
                                break;
                            default:
                                history.push('/home/calculation');
                                break;
                        }
                    }
                }
            }
            window.scrollTo(0, 0);
        }
    };

    const childrenWithProps = React.Children.map(children, (child, i) => {
        if (i == step) {
            return React.cloneElement(child as ReactElement<Stepable>, {
                goToNextStep,
                goToPrevStep
            });
        }
        return null;
    });

    return <>{childrenWithProps}</>;
};

export default withRouter(StepManager);
